import React, { useState, useEffect } from 'react';

const CompanyFilter = ({ onFilterChange, initialFilters }) => {
  const [name, setName] = useState(initialFilters?.name || '');
  const [email, setEmail] = useState(initialFilters?.email || '');
  
  // Apply filter changes when component mounts with initialFilters
  useEffect(() => {
    if (initialFilters) {
      setName(initialFilters.name || '');
      setEmail(initialFilters.email || '');
    }
  }, [initialFilters]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleApplyFilters = () => {
    const filters = {
      name: name.trim() || undefined,
      email: email.trim() || undefined
    };
    onFilterChange(filters);
  };

  const handleResetFilters = () => {
    setName('');
    setEmail('');
    
    // Explicitly send empty filters to parent component
    onFilterChange({
      name: undefined,
      email: undefined
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleApplyFilters();
    }
  };

  return (
    <div className="bg-white p-4 mb-4 rounded-lg shadow">
      <div className="flex flex-col space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="company-name" className="block text-sm font-medium text-gray-700 mb-1">
              Sponsor Name
            </label>
            <input
              id="company-name"
              type="text"
              value={name}
              onChange={handleNameChange}
              onKeyDown={handleKeyDown}
              placeholder="Search by sponsor name..."
              className="w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px]"
            />
          </div>
          
          <div>
            <label htmlFor="company-email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              id="company-email"
              type="text"
              value={email}
              onChange={handleEmailChange}
              onKeyDown={handleKeyDown}
              placeholder="Search by email..."
              className="w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px]"
            />
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button
            onClick={handleApplyFilters}
            className="px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 min-h-[44px] flex-1 md:flex-none"
          >
            Apply Filters
          </button>
          <button
            onClick={handleResetFilters}
            className="px-4 py-3 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 min-h-[44px] flex-1 md:flex-none"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyFilter; 